var _classCallCheck = require("/Users/tamir/work/websites/markidim/markidim_web/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/tamir/work/websites/markidim/markidim_web/node_modules/@babel/runtime/helpers/createClass");

/**
* Auth service
*
* This service is responsible for logging in and logging out
* the user. It uses both cl-api and cl-storage to manage the
* login and logout operations including storing the credentials
* in local storage for future use.
*/
var Rx = require('rx');

var CLApi = window.CLApi = require('../cl-api');

var CLStorage = window.CLStorage = require('../cl-storage');

var Auth =
/*#__PURE__*/
function () {
  "use strict";

  function Auth(props) {
    _classCallCheck(this, Auth);

    this.api = new CLApi();
  }

  _createClass(Auth, [{
    key: "login",
    value: function login(email, password, rememberMe) {
      var _this = this;

      return Rx.Observable.create(function (observer) {
        _this.api._login({
          email: email,
          password: password,
          rememberMe: rememberMe
        }).subscribe(function (loginResponse) {
          observer.onNext(loginResponse);
        }, function (error) {
          observer.onError(error);
        }, function () {
          return observer.onCompleted();
        });
      });
    }
  }, {
    key: "signup",
    value: function signup(email, password, invitationId, rememberMe) {
      var _this2 = this;

      return Rx.Observable.create(function (observer) {
        _this2.api._signup({
          email: email,
          password: password,
          invitation_id: invitationId,
          rememberMe: rememberMe
        }).subscribe(function (loginResponse) {
          observer.onNext(loginResponse);
        }, function (error) {
          observer.onError(error);
        }, function () {
          return observer.onCompleted();
        });
      });
    }
  }, {
    key: "resetPassword",
    value: function resetPassword(email, password, rememberMe) {
      var _this3 = this;

      return Rx.Observable.create(function (observer) {
        _this3.api._resetPassword({
          email: email,
          password: password,
          rememberMe: rememberMe
        }).subscribe(function (loginResponse) {
          observer.onNext(loginResponse);
        }, function (error) {
          observer.onError(error);
        }, function () {
          return observer.onCompleted();
        });
      });
    }
  }, {
    key: "logout",
    value: function logout() {
      var _this4 = this;

      return Rx.Observable.create(function (observer) {
        _this4.api._logout().subscribe(function (logoutResponse) {
          // Remove credentials from local storage
          CLStorage.clearLoginCredentials(); // Return response to caller

          observer.onNext(logoutResponse);
        }, function (error) {
          observer.onError(error);
        });
      });
    }
  }]);

  return Auth;
}();

module.exports = Auth;